import { useState } from 'react'
import { EMOJI, recentEmoji, rememberEmoji, searchEmoji } from '../lib/emoji.ts'

/**
 * Выбор эмодзи.
 *
 * Поиск по русским словам: «торт» находит и пирожное, и праздничный торт.
 * Искать по английским названиям, как это делают готовые наборы,
 * русскоязычной семье бессмысленно.
 */
export function EmojiPicker({
  onPick,
  onClose,
}: {
  onPick: (char: string) => void
  onClose: () => void
}) {
  const [group, setGroup] = useState(0)
  const [query, setQuery] = useState('')
  const [recent, setRecent] = useState(recentEmoji())

  const found = query.trim() ? searchEmoji(query) : null
  const items = found ?? EMOJI[group]?.items.map((i) => i.char) ?? []

  const pick = (char: string) => {
    rememberEmoji(char)
    setRecent(recentEmoji())
    onPick(char)
  }

  return (
    <div className="emoji-overlay" onClick={onClose}>
      <div className="emoji" onClick={(e) => e.stopPropagation()}>
        <input
          className="emoji-search"
          placeholder="Найти: торт, сердце, дом…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoFocus
        />

        {!query && recent.length > 0 && (
          <>
            <div className="emoji-title">Недавние</div>
            <div className="emoji-grid">
              {recent.map((char) => (
                <button key={'r' + char} className="emoji-item" onClick={() => pick(char)}>
                  {char}
                </button>
              ))}
            </div>
          </>
        )}

        {query && found?.length === 0 && <p className="empty-hint">Ничего не нашлось</p>}

        {!query && <div className="emoji-title">{EMOJI[group]?.name}</div>}

        <div className="emoji-grid">
          {items.map((char) => (
            <button key={char} className="emoji-item" onClick={() => pick(char)}>
              {char}
            </button>
          ))}
        </div>

        {!query && (
          <div className="emoji-tabs">
            {EMOJI.map((g, index) => (
              <button
                key={g.name}
                className={'emoji-tab' + (index === group ? ' is-active' : '')}
                onClick={() => setGroup(index)}
                title={g.name}
              >
                {g.icon}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
